import { render } from "./AddResult.vue?vue&type=template&id=65f976e9"
import script from "./AddResult.vue?vue&type=script&lang=js"
export * from "./AddResult.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__